export const personal = {
  name: "Rushil Shah",
  greeting: "Hi, I'm",
  roles: ["Software Engineer", "iOS & Mobile Developer", "sometimes Funny :)"],
  bio: "I love building things that scale — from multi-agent AI systems to mobile apps with 100K+ downloads.",
  about: [
    { icon: "🏢", text: "Software Engineer at Meta in the Bloks Integrations team, Menlo Park" },
    { icon: "🎓", text: "MS in Computer Science from Stony Brook University. BE in Computer Engineering from KJ Somaiya College of Engineering." },
    { icon: "💻", text: "I enjoy building software that solves real problems — from AI-powered performance tooling to apps used by 100K+ people worldwide." },
    { icon: "⚽", text: "When I'm not coding, I'm watching football. YNWA — Liverpool FC forever." },
  ],
  social: {
    github:   "https://github.com/Rushil10",
    linkedin: "https://www.linkedin.com/in/rushil10shah/",
    email:    "rushil.10.shah@gmail.com",
  },
  resume: "https://drive.google.com/uc?export=download&id=1ierhCcjxuVQEDfWc8bZCp4377C9WBPfu",
};
